<div id="sh-license-groups-list-loader">
	<sh-loader></sh-loader>
</div>
